const appHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
window.addEventListener('resize', appHeight);
appHeight();

function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function getCookie(c_name) {
  var c_value = document.cookie,
      c_start = c_value.indexOf(" " + c_name + "=");
  if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
  if (c_start == -1) {
      c_value = null;
  } else {
      c_start = c_value.indexOf("=", c_start) + 1;
      var c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) {
          c_end = c_value.length;
      }
      c_value = unescape(c_value.substring(c_start, c_end));
  }
  return c_value;
}

window.addEventListener('load', function() {
  const agegate = document.getElementById("agegate");
  const cookie = getCookie("agegate");

  if (agegate && !cookie) {
    agegate.classList.add("show");
    document.body.classList.add("no-scroll");
  }
  if (cookie) {
    if (cookie === "FR") {
      this.document.body.classList.add("country-france");
      console.log("france");
    } else if (cookie !== "FR") {
      this.document.body.classList.add("country-hors-france");
      console.log("hors-france");
    }
  }
});

window.addEventListener('load', function() {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== "refonte-lanson.myshopify.com" && links[i].hostname !== "lanson.com" && links[i].hostname !== this.window.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener nofollow';
    }
  }
});

window.addEventListener('load', function() {
  const countrySelect = document.getElementById("country-list");
  const localization = getCookie('localization');

  if (countrySelect) {
    console.log("countrySelect exists");

    countrySelect.value = localization;
  }
});

function modifQtyInput(productId, operation) {
  const qtyInput = document.querySelector("#quick-buy-qty-"+productId);
  const selectElem = document.querySelector("#quick-buy-select-"+productId);

  if (qtyInput && selectElem) {
    const selectedOption = selectElem.selectedOptions[0];
    const max_value = selectedOption.getAttribute("data-max-val");
    var my_value = qtyInput.valueAsNumber;

    if (operation == "+" && my_value < max_value) {
      my_value++;
    } else if (operation == "-" && my_value > 1) {
      my_value--;
    }
    qtyInput.value = parseInt(my_value);
  }
  updateQuickbuyTotal(productId);
}

function updateQuickbuyTotal(productId) {
  const selectElem = document.querySelector("#quick-buy-select-"+productId);
  const qtyElem = document.querySelector("#quick-buy-qty-"+productId);
  const totalElem = document.querySelector("#quick-buy-popup-total-"+productId);

  if (selectElem && totalElem && qtyElem) {
    const variantPrice = selectElem.selectedOptions[0].getAttribute("data-price");
    const qtyValue = qtyElem.value;
    var total = 0;

    total = parseInt(variantPrice) * qtyValue;
    totalElem.textContent = total.toString() + ",00 €";
  }
}

function closeQuickbuyPopup(query, event) {
  if (event.target !== event.currentTarget) return;

  const target = document.getElementById(query);

  if (target) {
    target.classList.remove('show-popup');
  }
}
